<template>
  <div id="">
    <div style="padding-top: 20px;background: #fff;height: 400px;">
      <el-form size="small" ref="ruleForm" label-width="80px" label="top" :model="ruleForm" :rules="rules"
        class="demo-ruleForm">
        <el-form-item :label="$t('message.table.oldPW')" prop="oldLoginPwd">
          <el-input style="width: 100%;" v-model="ruleForm.oldLoginPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.table.newPW')" prop="loginPwd">
          <el-input style="width: 100%;" v-model="ruleForm.loginPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.table.newPWagain')" prop="loginPwdAgain">
          <el-input style="width: 100%;" v-model="ruleForm.loginPwdAgain" type="password"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('message.button.save') }}</el-button>
          <el-button @click="resetForm('ruleForm')">{{ $t('message.button.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style scoped></style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      ruleForm: {
        oldLoginPwd: "",
        loginPwd: '',
        loginPwdAgain: "",
      },
      rules: {
        oldLoginPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        loginPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        loginPwdAgain: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() { },
  methods: {
    submitForm(formName) {
      var vm = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var session = window.sessionStorage.getItem('userContext');
          session = JSON.parse(session);
          if (vm.ruleForm.loginPwd == vm.ruleForm.loginPwdAgain) {
            //console.log(vm.ruleForm.loginPwd);
            var obj = {
              id: session.id,
              oldLoginPwd: vm.ruleForm.oldLoginPwd,
              loginPwd: vm.ruleForm.loginPwd,
            };
            axios.post('/pmdm/admin/user/changePwd', obj)
              .then(function (res) {
                //console.log(res);
                if (res.data.code == 200) {
                  vm.open();
                } else {
                  vm.$message.error(this.$t('message.error.change'));
                };
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
            vm.$message.error(this.$t('message.table.PWnotSame'));
          }
          //console.log(session);
        } else {
          vm.$message.error(this.$t('message.error.save'));
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    open() {
      this.$alert(this.$t('message.tips.changePW'), this.$t('message.tips.tip'), {
        confirmButtonText: this.$t('message.button.affirm'),
        callback: () => {
          window.sessionStorage.clear();
          this.$router.push("/index");
        }
      });
    }
  },
  created() {

  }
};
</script>